<div class="c-overlay c-overlay--fixed c-overlay--tp" *ngIf="vm.chats">
	<div class="o-grid o-grid--bottom">
		<div class="o-grid__cell u-no-p">
			<button-conversations [(chats)]="vm.chats" [limit]="vm.limit" class="u-hidden@up-to-md"></button-conversations>
		</div>
		<div class="o-grid__cell o-grid__cell--w-fixed u-no-p">
			<div class="o-grid">
				<div class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--slim" *ngFor="let chat of vm.chats | arrayLimitTo : vm.limit">
					<item-conversation [chat]="chat" [(isInfoHidden)]="vm.isInfoHidden"></item-conversation>
				</div>
			</div>
		</div>
	</div>
</div>
